/**
 * 图表组件注册轻量常量。
 *
 * DashboardLayout 按 chart_type 选择 ChartTragCard 等卡片组件的分支列表。
 */

import { ChartType, type TChartType } from '@dbl/core/chart';

/**
 * DashboardLayout：走 ChartTragCard（ECharts 类）渲染分支的 chart_type，不含 Table / BigNumber 等专用卡片。
 *
 * @core DashboardLayout/index 路由分支与 ChartTragCard 族共用；不属于单一 TragCard 组件私有。
 */
export const CHART_TRAG_CARD_TYPE_SET = new Set<TChartType>([
  ChartType.StackBar,
  ChartType.Bar,
  ChartType.Line,
  ChartType.Pie,
  ChartType.EventLine,
  ChartType.MixedChart,
  ChartType.Map,
  ChartType.WordCloud,
  ChartType.HorizontalBarChart,
  ChartType.PercentStackBar,
  ChartType.PercentLine,
]);
